import { RECEIVE_CONFIG } from '../ActionsConst';
import { setProductSizeMetadata } from '../services/product-type/ProductTypeService';
import ProductsServiceClient from '../../clients/ProductsService/ProductsServiceClient';
import AccountServiceClient from '../../clients/AccountService/AccountServiceClient';
import UserServiceClient from '../../clients/UserService/UserServiceClient';

let userResponse;

export const receiveConfigAction = (config) => ({
  type: RECEIVE_CONFIG,
  config,
});

// Used by PACT
export const fetchUser = (baseApiUrl) => {
  if (typeof userResponse === 'undefined') {
    userResponse = UserServiceClient.getUser(baseApiUrl);
  }

  return userResponse;
};

export const requestConfig = (baseApiUrl) => (dispatch) => {
  const fetchAccountConfig = AccountServiceClient.getAccount(baseApiUrl);
  const fetchUserConfig = fetchUser(baseApiUrl);

  return (
    Promise.all([fetchAccountConfig, fetchUserConfig])
      .then((responses) => {
        const accountConfig = responses[0];
        const userConfig = responses[1];
        return { ...accountConfig, ...userConfig };
      })
      /* In the Full Upload flow, Product Size Selection requires information about the available sizes from the selected
    product before rendering the page /products/upload/<insert-product-name>. It calls getFullUploadProductSizes().

    If the Product Size Selection page is visited directly from the URL or refreshed, the response with the
    productSizeMetadata has not been received yet and the page will render with a 'Sorry, we couldn't find any
    <insert-product-name> sizes'.

    The extra delay in the promise ensures that the productSizesMetadata has been received
    before dispatching the final RECEIVE_CONFIG action. */
      .then((jsonConfig) => {
        return ProductsServiceClient.getProductSizes(baseApiUrl, jsonConfig.selectedStoreCode)
          .then(setProductSizeMetadata)
          .then(() => jsonConfig);
      })
      .then((jsonConfig) => {
        dispatch(receiveConfigAction(jsonConfig));
        return jsonConfig;
      })
  );
};
